import Cookies from "js-cookie";
import axiosInstance from "./index.services";
import { axiosCallProp, endpointProp } from "./interface.service";

export const getOptions = () => {
  const accessToken =
    (Cookies.get("access") || sessionStorage.getItem("access")) ?? "no-token";
  if (Cookies.get("access") || sessionStorage.getItem("access")) {
    return {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
  }
};

const endpoint: endpointProp = {
  auth: {
    login: "/accounts/gettoken/",
    getOtp: "/accounts/send-otp/",
    verifyOtp: "/accounts/verify-otp/",
    resetPassword: "/accounts/reset-password/",
    refresh: "/accounts/refresh-token/",
  },
  user: "/user/",
  userme: "/user/me/",
  drag: "/drag-item/",
  "bulk-delete": "/bulk-delete/",
  groups: "/groups/",
  permissions: "/permissions/grouped_by_model/",
  groupextension: "/groupextension/",
  "blog-tags": "/blog-tags/",
  "blog-category": "/blog-category/",
  "blog-category-linked": "/blog-category/linked",
  "giveaway-templates": "/giveaway-templates/",
  blog: "/blog/",
  branding: "/branding/",
  "certificate-pending-course-batches": "/certificate/pending-course-batches/",
  "experience-level": "/experience-level/",
  career: "/career/",
  "certificate": "/certificate/",
  "certificate-save-only": "/certificate/save-only/",
  "certificate-save-and-send": "/certificate/save-and-send/",
  "certificate-webhook-config": "/certificate-webhook-config/",
  contactus: "/contactus/",
  uploadimage: "/custom-gallery/",
  activitylog: "/activitylog/",
  "change-password": "/user/change-password/",
  level: "/level/",
  "course-description": "/course-description/",
  duration: "/duration/",
  category: "/category/",
  batch: "/batch/",
  subjects: "/subjects/",
  "courses-batches-with-templates":
    "/templates/courses-batches-with-templates/",
  course: "/course/",
  "course-bulk-price": "/course/bulk-update-price/",
  "mentor-course-linked": "/mentor/course-linked/",
  "success-story-studnet": "/success-story/student-list/",
  "success-story-team-members": "/success-story/team-members/",
  "mentor-designation": "/mentor/designation/",
  "career-exprience": "/career/exprience_level/",
  "course-category-counts": "/course/course-category-counts/",
  enrollment: "/enrollment/",
  giveaway: "/giveawawy/",
  managesource: "/source/",
  enrollmenttostudent: "/enrollmenttostudent/",
  import: "/import-excel/student/",
  faqs: "/faqs/",
  "forms-category": "/forms-category/",
  forms: "/forms/",
  "request-form": "/request-form/",
  industryallies: "/industryallies/",
  journey: "/journey/",
  "journey-section-counts": "/journey/section-counts/",
  mentor: "/mentor/",
  mentorselect: "/user/mentors/",
  moments: "/moments/",
  "bulk-update": "/blog/bulk-update/",
  student: "/student/",
  studentselect: "/student/student-name/",
  successstory: "/success-story/",
  successquotations: "/successquotations/",
  successimage: "/successimage/",
  successdescription: "/successdescription/",
  successcomponentposition: "/successcomponentposition/",
  templates: "/templates/",
  testimonial: "/testimonial/",
  "testimonial-counts": "/testimonial/testimonial-counts/",
  "enterprise-testimonials": "/enterprise-testimonials/",
  "enterprise-cherish-moments": "/enterprise/",
  "home-cherish-moments": "/home-cherish/",
  designation: "/designation/",
  "course-batch": "/course-batch/",
  "student-placement": "/student-placement/",
  teamsLicense: "/teams-license/",
  payment: "/payment/",
  uniquePaymentNumber: "/uniquePaymentNumber/",
  paymentmode: "/paymentmode/",
  discount: "/discount/",
  "discount-calculate": "/discount-calculate/",
  termsconditions: "/termsconditions/",
  privacypolicy: "/privacypolicy/",
  invoice: "/invoice/",
  "invoice-batch-summary": "/invoice/batch-summary/",
  custompage: "/custompage/",
  "invoice-by-student": "/invoice-by-student/",
  "course-batch-amounts": "/course/batch-amounts/",
  "team-member": "/team-member/",
  "import-excel-student": "/import-excel/student/",
  "invoice-email": "/invoice-email/",
  "pending-course-batches": "/certificate/pending-course-batches/",
  notification: "/notification/",
  "notification-as-read": "/notification/mark-as-read/",
  "mark-all-as-read": "/notification/mark-all-as-read/",
  "email-sent": "/email-sent-upcoming-course/",
  "student-batch-amounts": "/invoice-by-student/student-batch-amounts/",
  "unique-course-batch-student": "/course-batch/unassigned-for-student/",
  "remove-coursebatch": "/student/remove-coursebatch/",
  "enrollment-course-batch": "/enrollment/course-batch/",
  "course-batch-with-invoices": "/course-batch/with-invoices/",
  "course-type": "/course-type",
  festival: "/festival/",
  redirect: "/redirect/",
  popup: "/popup/",
  //Cricket endpoint ---- start
  "cricket-match": "cricket-match",
  "cricket-match-winners": "",
  "cricket-teams": "cricket-team",
  "cricket-predictions": "cricket-match-prediction/leaderboard-crm",
  "cricket-userdetails": "cricket-user",
};

/* get custom query */
const getQuery = (params: { [key: string]: any }) => {
  if (params === undefined) return "";
  const queryString = Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
  return queryString ? `?${queryString}` : "";
};

/* get custom param */
const getParam = (id: number | string | undefined) => {
  return id ? `${id}/` : "";
};

// const getBody = (body: any) => {
//   const isFile = (value: any) => value instanceof File || value instanceof Blob;
//   const isFileArray = (value: any) =>
//     Array.isArray(value) && value.every(isFile);

//   if (body instanceof Array) {
//     const formData = new FormData();
//     body.forEach((item, itemIndex) => {
//       if (typeof item === "object" && item !== null) {
//         // Iterate over each key in the object
//         Object.keys(item).forEach((key) => {
//           if (isFile(item[key])) {
//             formData.append(`data[${itemIndex}][${key}]`, item[key]);
//           } else if (isFileArray(item[key])) {
//             // If the value is an array of files
//             item[key].forEach((file: File | Blob, fileIndex: number) => {
//               formData.append(`data[${itemIndex}][${key}][${fileIndex}]`, file);
//             });
//           } else if (Array.isArray(item[key])) {
//             // Handle arrays of non-file values inside objects
//             item[key].forEach((value, valueIndex) => {
//               formData.append(
//                 `data[${itemIndex}][${key}][${valueIndex}]`,
//                 value
//               );
//             });
//           } else {
//             // Handle normal values
//             formData.append(`data[${itemIndex}][${key}]`, item[key]);
//           }
//         });
//       }
//     });
//     console.log("API body", body);
//     return formData;
//   } else {
//     Object.keys(body).forEach((key) => {
//       if (body[key] === undefined) {
//         delete body[key];
//       }
//     });

//     const containsFile = Object.values(body).some(
//       (value) => isFile(value) || isFileArray(value)
//     );
//     if (containsFile) {
//       const formData = new FormData();
//       Object.keys(body).forEach((key) => {
//         if (isFileArray(body[key])) {
//           body[key].forEach((file: File | Blob, index: number) => {
//             formData.append(`${key}[${index}]`, file);
//           });
//         } else if (isFile(body[key])) {
//           formData.append(key, body[key]);
//         } else {
//           formData.append(key, body[key]);
//         }
//       });
//       console.log("API body", body);
//       return formData;
//     }
//     console.log("API body", body);
//     return body;
//   }
// };

/**
 * Converts a body object or array into FormData or JSON based on content.
 * Explicitly handles empty arrays to ensure keys are included.
 * @param body - Request body (object or array).
 * @returns FormData or JSON object.
 */
// const getBody = (body: Record<string, any> | Array<Record<string, any>> | undefined) => {
//   if (!body) return undefined;

//   const isFile = (value: any): boolean => value instanceof File || value instanceof Blob;
//   // const isFileArray = (value: any): boolean => Array.isArray(value) && value.every(isFile);
//   const isFileArray = (data: any): boolean => {
//   return (
//     Array.isArray(data) &&
//     data.length > 0 &&
//     data.every((item) => item instanceof File || item instanceof Blob)
//   );
// };

//   // Helper function to append data to FormData recursively
//   const appendFormData = (formData: FormData, data: any, parentKey = "") => {
//     if (isFile(data)) {
//       formData.append(parentKey, data);
//     } else if (isFileArray(data)) {
//       console.log("this is ISFILEARRAY data in APPENDFORMDATA", data, parentKey);
//       data.forEach((file: File | Blob, index: number) => {
//         formData.append(`${parentKey}[${index}]`, file);
//       });
//     } else if (Array.isArray(data)) {
//       console.log("this is ISARRAY data in APPENDFORMDATA", data, parentKey);
//       if (data.length === 0 && parentKey) {
//         formData.append(parentKey, "[]"); // Explicitly include empty arrays
//       } else {
//         data.forEach((value, index) => {
//           appendFormData(formData, value, `${parentKey}[${index}]`);
//         });
//       }
//     } else if (typeof data === "object" && data !== null) {
//       console.log("this is OBJECT data in APPENDFORMDATA", data, parentKey);
//       Object.entries(data).forEach(([key, value]) => {
//         if (value !== undefined) {
//           const newKey = parentKey ? `${parentKey}[${key}]` : key;
//           appendFormData(formData, value, newKey);
//         }
//       });
//     } else if (data !== undefined) {
//       console.log("this is undefined data in APPENDFORMDATA", data, parentKey);
//       formData.append(parentKey, String(data));
//     }
//   };

//   // Check if body contains files
//   const containsFile = (value: any): boolean => {
//     if (isFile(value) || isFileArray(value)) return true;
//     if (Array.isArray(value)) return value.some(containsFile);
//     if (typeof value === "object" && value !== null) return Object.values(value).some(containsFile);
//     return false;
//   };

//   if (Array.isArray(body)) {
//     const formData = new FormData();
//     appendFormData(formData, body, "data");
//     console.log("API body (FormData)", body);
//     return formData;
//   }

//   // Remove undefined fields from body
//   const cleanedBody = Object.fromEntries(
//     Object.entries(body).filter(([, value]) => value !== undefined)
//   );

//   if (containsFile(cleanedBody)) {
//     const formData = new FormData();
//     Object.entries(cleanedBody).forEach(([key, value]) => {
//   appendFormData(formData, value, key);
// });
//     console.log("API body (FormData)", cleanedBody);
//     return formData;
//   }

//   console.log("API body (JSON)", cleanedBody);
//   return cleanedBody;
// };
/** nested object file */
const getBody = (body: any) => {
  const isFile = (value: any) => value instanceof File || value instanceof Blob;

  // const isFileArray = (value: any) =>
  //   Array.isArray(value) && value.every(isFile);
  const isFileArray = (data: any): boolean => {
    return (
      Array.isArray(data) &&
      data.length > 0 && // <- 👈 this line fixes it
      data.every((item) => item instanceof File || item instanceof Blob)
    );
  };

  const objectContainsFile = (value: any): boolean => {
    if (value === null || value === undefined) {
      return false;
    }
    if (isFile(value) || isFileArray(value)) {
      return true;
    }
    if (Array.isArray(value)) {
      return value.some((v) => objectContainsFile(v));
    }
    if (typeof value === "object") {
      return Object.values(value).some((v) => objectContainsFile(v));
    }
    return false;
  };

  const appendFormData = (formData: FormData, data: any, parentKey = "") => {
    if (isFile(data)) {
      formData.append(parentKey, data);
    } else if (isFileArray(data)) {
      data.forEach((file: File | Blob, index: number) => {
        formData.append(`${parentKey}[${index}]`, file);
      });
    } else if (Array.isArray(data)) {
      // console.log("HERE THE MENTOR SHOULD COME", data, parentKey);
      data.forEach((value, index) => {
        const key = parentKey ? `${parentKey}[${index}]` : `${index}`;
        appendFormData(formData, value, key);
      });
    } else if (typeof data === "object" && data !== null) {
      Object.keys(data).forEach((key) => {
        const value = data[key];
        const newKey = parentKey ? `${parentKey}[${key}]` : key;
        appendFormData(formData, value, newKey);
      });
    } else if (data !== undefined) {
      formData.append(parentKey, data);
    }
  };

  if (Array.isArray(body)) {
    const formData = new FormData();
    appendFormData(formData, body, "data");
    console.log("API body (FormData)", body);
    return formData;
  } else {
    // Remove undefined fields
    Object.keys(body).forEach((key) => {
      if (body[key] === undefined) {
        delete body[key];
      }
    });

    if (objectContainsFile(body)) {
      const formData = new FormData();
      appendFormData(formData, body);
      console.log("API body (FormData)", body);
      return formData;
    } else {
      console.log("API body (JSON)", body);
      return body;
    }
  }
};

/* api useAxiosCall */
const useAxiosCall = async ({
  params,
  endpoint,
  method,
  id,
  body,
}: axiosCallProp) => {
  const controller = new AbortController();
  try {
    const query = getQuery(params);
    const param = getParam(id);
    console.log("THIS IS THE BODY IN useAXIOScall", body);
    const requestbody = body && getBody(body);
    console.log("THIS IS THE REquest BODY IN useAXIOScall", requestbody);
    if (!endpoint) {
      throw new Error("Endpoint is required");
    }

    switch (method?.toUpperCase()) {
      case "GET": {
        let { data, status } = await axiosInstance.get(
          endpoint + param + query,
          { ...getOptions(), signal: controller.signal }
        );
        return { data, status };
      }

      case "POST": {
        let { data, status } = await axiosInstance.post(
          endpoint + param + query,
          requestbody,
          getOptions()
        );
        console.log("THIS IS THE RETURN", data, status);
        return { data, status };
      }

      case "PUT": {
        let { data, status } = await axiosInstance.put(
          endpoint + param + query,
          requestbody,
          getOptions()
        );
        return { data, status };
      }

      case "PATCH": {
        let { data, status } = await axiosInstance.patch(
          endpoint + param + query,
          requestbody,
          getOptions()
        );
        return { data, status };
      }

      case "DELETE": {
        let { data, status } = await axiosInstance.delete(
          endpoint + param + query,
          getOptions()
        );
        return { data, status };
      }

      default:
        return;
    }
  } catch (err: any) {
    return Promise.reject(err);
  }
};

export { endpoint, useAxiosCall };
